import { useCallback } from "react";
import ReactPaginate from "react-paginate";
import { EMPTY_STRING, DEFAULT_LIMIT } from "../../../constants";

const MARGIN_PAGES_DISPLAYED = 2;
const PAGE_RANGE_DISPLAYED = 2;

const Pagination = ({ handlePagination, pagesCount, activePage, count }) => {
  const handleOnPageChange = useCallback(
    (pageNumber) => {
      handlePagination(pageNumber.selected);
    },
    [handlePagination]
  );

  return (
    count > DEFAULT_LIMIT && (
      <div className="mt-auto">
        <ReactPaginate
          forcePage={activePage}
          nextLabel={EMPTY_STRING}
          previousLabel={EMPTY_STRING}
          containerClassName="flex flex-row text-gray-600 text-lg justify-center items-center"
          breakLabel="..."
          breakClassName="text-gray-600 pt-1"
          pageClassName="mx-2 pt-1 px-2"
          activeClassName="text-blue-900 border-t-[3px] border-blue-900 text-base"
          onPageChange={handleOnPageChange}
          pageRangeDisplayed={PAGE_RANGE_DISPLAYED}
          marginPagesDisplayed={MARGIN_PAGES_DISPLAYED}
          pageCount={pagesCount ? pagesCount : 1}
          renderOnZeroPageCount={null}
        />
      </div>
    )
  );
};

export default Pagination;
